module.exports = __webpack_public_path__ + "img/logoadeConnect.9ed21112.png";